import { render, staticRenderFns } from "./NewGameCategory.vue?vue&type=template&id=56bbd358&"
import script from "./NewGameCategory.vue?vue&type=script&lang=js&"
export * from "./NewGameCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports